import { ShuffleDto } from "../../dto/shuffle/shufflesdto";
import { APIResponse, APIResponseDtoImpl } from "../apiresponse";

export interface ShuffleResponse extends APIResponse 
{
    getShuffleDto(): ShuffleDto;
}

export class ShuffleResponseDtoImpl extends APIResponseDtoImpl implements ShuffleResponse 
{
    private shuffleResponseDto : ShuffleDto;

    getShuffleDto(): ShuffleDto
    {
        return this.shuffleResponseDto;
    }
    setShuffleDto(shuffleResponseDto: ShuffleDto)
    {
        this.shuffleResponseDto = shuffleResponseDto;
    }
}




// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/shuffle/shuffleresponse.ts